import { API, BASE_URL_AI, axiosClient } from "../../../Constant/apiConstant";

export const getProjectPoolsService = async () => {
  const res = await axiosClient.get(
    `${BASE_URL_AI}${API.V1.AI.PROJECT_POOLS}`
  );
  return res?.data;
};

export const createProjectPoolService = async (data) => {
  const res = await axiosClient.post(
    `${BASE_URL_AI}${API.V1.AI.PROJECT_POOLS}`,
    data
  );
  return res?.data;
};

export const updateProjectPoolService = async (id, data) => {
  const res = await axiosClient.put(
    `${BASE_URL_AI}${API.V1.AI.PROJECT_POOLS}/${id}`,
    data
  );
  return res?.data;
};

export const deleteProjectPoolService = async (id, force = false) => {
  const res = await axiosClient.delete(
    `${BASE_URL_AI}${API.V1.AI.PROJECT_POOLS}/${id}`,
    { params: force ? { force: true } : undefined }
  );
  return res?.data;
};

export const replaceProjectPoolsService = async (pools) => {
  const res = await axiosClient.put(
    `${BASE_URL_AI}${API.V1.AI.PROJECT_POOLS}`,
    { pools }
  );
  return res?.data;
};
